import React, { useState, useEffect, useRef } from 'react';
import FadeIn from '../common/FadeIn';

const statsData = [
  {
    number: "20+",
    labelLine1: "WEBSITES",
    labelLine2: "LAUNCHED"
  },
  {
    number: "10+",
    labelLine1: "DESIGNS",
    labelLine2: "TO CHOOSE FROM"
  },
  {
    number: "16+",
    labelLine1: "Happy",
    labelLine2: "Clients"
  },
  {
    number: "100%",
    labelLine1: "Responsive",
    labelLine2: "Designs"
  }
];

const CounterUp = ({ value, duration = 2200 }) => {
  const [count, setCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const ref = useRef(null);

  const numericValue = parseInt(value.replace(/\D/g, ''), 10) || 0;
  const suffix = value.replace(/[0-9]/g, '');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          let startTimestamp = null;
          const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            const easeProgress = 1 - Math.pow(1 - progress, 3);
            setCount(Math.floor(easeProgress * numericValue));
            if (progress < 1) {
              window.requestAnimationFrame(step);
            } else {
              setCount(numericValue);
            }
          };
          window.requestAnimationFrame(step);
        }
      },
      { threshold: 0.2 }
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [numericValue, duration, hasAnimated]);

  return (
    <span ref={ref}>
      {count}{suffix}
    </span>
  );
};

const AboutStatsSection = () => {
  return (
    <section className="w-full bg-[#f9f9f5] pb-20 sm:pb-24 md:pb-28 px-4 sm:px-6 md:px-10 lg:px-16 text-[#1C1917]">
      <div className="max-w-[1140px] mx-auto">
        <FadeIn className="w-full border-t border-b border-[#E8E2D9] py-10 sm:py-12 md:py-14">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 lg:gap-8 text-center items-start">
            {statsData.map((stat, index) => (
              <div key={index} className="flex flex-col items-center justify-center px-1">
                <span className="font-saolDisplayItalic text-[36px] sm:text-[44px] md:text-[52px] lg:text-[72px] xl:text-[92px] leading-[1.1] tracking-[0em] font-light mb-2 sm:mb-3 whitespace-nowrap">
                  <CounterUp value={stat.number} duration={2200} />
                </span>
                <div className="font-interDisplayMedium text-[11px] sm:text-[12px] md:text-[12.5px] lg:text-[15px] uppercase tracking-[0.08em] md:tracking-[0.1em] leading-[1.6] md:leading-[1.8] font-normal text-center">
                  <div>{stat.labelLine1}</div>
                  <div>{stat.labelLine2}</div>
                </div>
              </div>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default AboutStatsSection;
